<div class="trigger-info">
  <div class="handler">{{ trigger[0] }}</div>
  <div class="trigger">{{ trigger[1].options | json }}</div>
  <!-- <div class="status" [ngClass]="trigger[1].active ? 'active' : 'passive'" [class.data-transfering]="trigger[1].dataTransfering">
    </div> -->
</div>
